import { connect } from 'react-redux';
import { fetchColumns, fetchRules, updateRules, setFilters } from '../../actions/index';
import Rules from '../../components/Rules/Rules';
// import { filteredColumns } from '../../reducers/reducers-filter-columns';

const mapStateToProps = state => {
    return {
        columns: state.columns,
        rules: state.rules,
        filteredColumns: state.filteredColumns,
        rowFilter: state.rowFilters,
        invalidWorktags: state.validateWorkTags,
        error: state.errorOnScan 
    }
};

export default connect(
    mapStateToProps,
    { fetchColumns, fetchRules, updateRules, setFilters }
)(Rules);


// WEBPACK FOOTER //
// ./src/containers/Rules/RulesContainer.js